var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card"},[_c('div',[_c('div',[_vm._v(_vm._s(_vm.title))])]),_c('a',{staticStyle:{"color":"#5f5f5f"},on:{"click":_vm.detail}},[_vm._v("更多 >")])])}
var staticRenderFns = []

export { render, staticRenderFns }